
import { Component, Prop, Vue, TSX } from 'vue-facing-decorator'
import FieldEdit from './field-edit.vue'
import { getFormTypeName } from '@/common/sign'
interface Props {
  modelValue?: any[]
}
@Component({
  emits: ['update:modelValue']
})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop()
  modelValue: any[];

  get rows() {
    return this.modelValue || [];
  }

  getFormatType(type) {
    return getFormTypeName(type);
  }

  /**
   * 结构变化（增删/移动）后一定发一份新数组，不改父级传进来的那个引用，
   * 否则父级拿到的还是同一个数组、可能不触发重渲染
   */
  sync() {
    this.$emit('update:modelValue', [...this.rows]);
  }

  async editItem(index) {
    let data;
    try {
      data = await this.$dialog({
        title: this.rows[index].id ? '编辑字段' : '新增字段',
        props: { width: '600px' },
        content: () => <FieldEdit modelValue={{ ...this.rows[index] }} />,
      }, 'sign-field');
    } catch (e) {
      /** 取消时 $dialog 是 reject，不是 resolve 空值 */
      return;
    }
    if (!data) return;
    this.rows.splice(index, 1, data);
    this.sync();
  }

  async addItem() {
    let data;
    try {
      data = await this.$dialog({
        title: '新增字段',
        props: { width: '600px' },
        content: () => <FieldEdit modelValue={{
          name: '',
          placeholder: '',
          type: 1,
          isRequire: 0,
          isSystem: 0,
          content: null,
        }} />,
      }, 'sign-field');
    } catch (e) {
      return;
    }
    if (!data) return;
    /** 新字段不能带 id：带了后端会去找一条不属于本活动的表头，报「修改信息有误」 */
    delete data.id;
    this.rows.push(data);
    this.sync();
  }

  removeItem(index) {
    let row = this.rows[index];
    if (row?.isSystem == 1) return this.$error('系统字段不能删除');
    this.rows.splice(index, 1);
    this.sync();
  }

  changeRequire(row, value) {
    row.isRequire = value;
    this.sync();
  }

  swapArray(arr, index1, index2) {
    if (index1 < 0 || index1 >= arr.length || index2 < 0 || index2 >= arr.length) {
      return;
    }
    let temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
  }

  upIndex(index) {
    this.swapArray(this.rows, index, index - 1);
    this.sync();
  }

  downIndex(index) {
    this.swapArray(this.rows, index, index + 1);
    this.sync();
  }
}
